import styled from 'styled-components';

export const SubscriptionWrapper = styled.div`
  display: flex;
  background: linear-gradient(135deg, #caeaec 0%, #f6e9fe 100%);
  flex-direction: row;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  margin-top: 12px;
`;
